import { shallowRef } from 'vue';

/**
 * In-app replacement for window.confirm (blocked or auto-cancelled in embedded browsers, unstyled, not
 * translatable). One question at a time, shown by <ConfirmHost> at the app root; resolves true on OK.
 */
export interface ConfirmRequest {
  message: string;
  /** Set for promptDialog: the text field's starting value (resolves with the text instead of true). */
  input?: string;
  okLabel?: string;
  danger: boolean;
  resolve: (ok: boolean, text?: string) => void;
}
export const pendingConfirm = shallowRef<ConfirmRequest | null>(null);

const DANGER = /\b(delete|remove|revoke|unpair|reject|discard|leave|sign out|unpublish|reboot|clear)\b|حذف|إزالة/i;

export function confirmDialog(message: string, opts: { okLabel?: string; danger?: boolean } = {}): Promise<boolean> {
  pendingConfirm.value?.resolve(false);
  return new Promise((resolve) => {
    pendingConfirm.value = {
      message,
      okLabel: opts.okLabel,
      danger: opts.danger ?? DANGER.test(message),
      resolve: (ok) => {
        pendingConfirm.value = null;
        resolve(ok);
      },
    };
  });
}

/** In-app replacement for window.prompt: resolves with the entered text, or null on Cancel. */
export function promptDialog(message: string, initial = '', opts: { okLabel?: string } = {}): Promise<string | null> {
  pendingConfirm.value?.resolve(false);
  return new Promise((resolve) => {
    pendingConfirm.value = {
      message,
      input: initial,
      okLabel: opts.okLabel,
      danger: false,
      resolve: (ok, text) => {
        pendingConfirm.value = null;
        resolve(ok ? (text ?? '') : null);
      },
    };
  });
}
